// Constants
import {
  KYC_BIZUM_TIMER_LOCALSTORAGE_ID,
  KYC_BIZUM_WS_TIME_PROPS,
} from '../../constants/kyc-bizum.constants';
// Utilities
import { getKYCBizumTimerFromStorage } from '../../utils/kyc-bizum.utils';

const saveNewBizumTimerOnStorage = (seconds: number = KYC_BIZUM_WS_TIME_PROPS.timeout): void => {
  localStorage.setItem(KYC_BIZUM_TIMER_LOCALSTORAGE_ID, seconds.toString());
};

const saveNewBizumTimerOnStorageIfEmpty = (): void => {
  !getKYCBizumTimerFromStorage() && saveNewBizumTimerOnStorage();
};

const removeBizumTimerFromStorage = (): void => {
  localStorage.removeItem(KYC_BIZUM_TIMER_LOCALSTORAGE_ID);
};

const timerIsFinishedOnStorage = (): boolean =>
  Boolean(getKYCBizumTimerFromStorage() && Number(getKYCBizumTimerFromStorage()) - 1 <= 0);

export {
  removeBizumTimerFromStorage,
  saveNewBizumTimerOnStorageIfEmpty,
  saveNewBizumTimerOnStorage,
  timerIsFinishedOnStorage,
};
